<div class="p-15">
  <p class="TXT_TITLE">:: Select QA Code ::</p>

  <form [formGroup]="form">
    <input type="hidden" formControlName="HdItemAmount" />
    <input type="hidden" formControlName="DoAction" />

    <div style="text-align: center">
      <button type="button" (mouseover)="onMouseOver()" (click)="goAddQA()">
        SELECT
      </button>
    </div>
    <div class="mt-15 mb-15">
      <nz-table
        #requestItems
        nzBordered
        class="StyleTable"
        [nzData]="items"
        [nzShowPagination]="false"
        [nzPageSize]="items.length"
      >
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>QA Code</th>
            <th>QA Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of requestItems.data; let i = index">
            <td style="text-align: center">{{ i + 1 }}</td>
            <td style="text-align: center">
              <input
                type="checkbox"
                [id]="'itm' + i"
                [name]="'itm' + i"
                [value]="item.code"
                [checked]="checkQA(item.code)"
              />
            </td>
            <td class="ITEM">{{ item.code }}</td>
            <td class="ITEM">{{ item.description }}</td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td
              colspan="4"
              style="text-align: center; padding: 20px; color: #666"
            >
              No QA codes available.
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div style="text-align: center">
      <button type="button" (mouseover)="onMouseOver()" (click)="goAddQA()">
        SELECT
      </button>
    </div>
    <br />
  </form>
</div>
